import { useRef, useState } from 'react';
import api from '../api';

// Lightweight Markdown editor with toolbar for bold/italic, link, image/PDF upload, and YouTube/Vimeo embed shortcode insertion.
// The parent controls value/onChange.
export default function MarkdownEditor({ value, onChange }) {
  const [busy, setBusy] = useState(false);
  const taRef = useRef(null);

  const applyAround = (left, right = left) => {
    const ta = taRef.current;
    if (!ta) return;
    const start = ta.selectionStart ?? 0;
    const end = ta.selectionEnd ?? 0;
    const before = value.slice(0, start);
    const sel = value.slice(start, end);
    const after = value.slice(end);
    const next = before + left + (sel || '') + right + after;
    onChange(next);
    setTimeout(() => {
      ta.focus();
      const pos = start + left.length + (sel ? sel.length : 0);
      ta.setSelectionRange(pos, pos);
    }, 0);
  };

  const insertAtCursor = (text) => {
    const ta = taRef.current;
    if (!ta) return;
    const start = ta.selectionStart ?? 0;
    const end = ta.selectionEnd ?? 0;
    const before = value.slice(0, start);
    const after = value.slice(end);
    const next = before + text + after;
    onChange(next);
    setTimeout(() => {
      ta.focus();
      const pos = start + text.length;
      ta.setSelectionRange(pos, pos);
    }, 0);
  };

  const uploadFile = async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    setBusy(true);
    try {
      const res = await api.post('/kb/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      return res.data?.url;
    } finally {
      setBusy(false);
    }
  };

  const onPickFile = async (accept) => {
    const inp = document.createElement('input');
    inp.type = 'file';
    if (accept) inp.accept = accept;
    inp.onchange = async () => {
      const f = inp.files && inp.files[0];
      if (!f) return;
      const url = await uploadFile(f);
      if (!url) return;
      if (/^image\//i.test(f.type)) insertAtCursor(`\n![${f.name}](${url})\n`);
      else insertAtCursor(`\n[${f.name}](${url})\n`);
    };
    inp.click();
  };

  const addYouTube = () => {
    const id = prompt('YouTube-Video-ID oder URL eingeben:');
    if (!id) return;
    // Store as shortcode, renderer will convert safely
    insertAtCursor(`\n:::youtube ${id}\n`);
  };
  const addVimeo = () => {
    const id = prompt('Vimeo-Video-ID oder URL eingeben:');
    if (!id) return;
    insertAtCursor(`\n:::vimeo ${id}\n`);
  };

  return (
    <div>
      <div style={{ display:'flex', gap:6, marginBottom:6, flexWrap:'wrap' }}>
        <button type="button" onClick={()=>applyAround('**')}>B</button>
        <button type="button" onClick={()=>applyAround('*')}>I</button>
        <button type="button" onClick={()=>insertAtCursor('\n[Link-Text](https://)\n')}>Link</button>
        <button type="button" disabled={busy} onClick={()=>onPickFile('image/*')}>Bild hochladen</button>
        <button type="button" disabled={busy} onClick={()=>onPickFile('application/pdf,application/*')}>Datei hochladen</button>
        <button type="button" onClick={addYouTube}>YouTube</button>
        <button type="button" onClick={addVimeo}>Vimeo</button>
        {busy && <span style={{ fontSize:12, color:'#bbb' }}>Upload…</span>}
      </div>
      <textarea ref={taRef} value={value} onChange={e=>onChange(e.target.value)} style={{ width:'100%', minHeight:200 }} />
    </div>
  );
}
